import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { WFormsTableWrapper } from '../table/WFormsTableWrapper';
import { IDs } from '../IDs';
import { RechteService } from '../../services/rechte_service';
import style from './WRechte.less';
import { WDnd } from '../forms/WDnd';

interface WRechteGroupProps extends React.ClassAttributes<any> {
    modul: string;
    stamp: number;
    rechteBasis: any;
    costumClass?: string;
    formLayout?: string;
    onDataChange?: () => void;
}

interface WRechteGroupState {
    group: Array<any>;
    showZuordnenDialog: any;
    showItem: any;
    groupRechteLists: any;
    groupUsersLists: any;
}

export class WRechteGroup extends React.Component<WRechteGroupProps, WRechteGroupState> {

    constructor(props: any) {
        super(props);

        this.state = {
            group: [],
            showZuordnenDialog: false,
            showItem: {},
            groupRechteLists: {},
            groupUsersLists: {}
        };

        this.updateGroup = this.updateGroup.bind(this);
        this.prepareGroupRechteLists = this.prepareGroupRechteLists.bind(this);
        this.prepareGroupUsersLists = this.prepareGroupUsersLists.bind(this);
        this.saveGroupRechteLists = this.saveGroupRechteLists.bind(this);
        this.saveGroupUsersLists = this.saveGroupUsersLists.bind(this);
    }

    @lazyInject(RechteService) private rechteService: RechteService;

    private title = {
        SELECTED: 'zugeordnet',
        OPTIONS: 'nicht zugeordnet'
    };

    componentDidMount() {
        if (this.state.group.length === 0) {
            this.updateGroup();
        }
    }

    componentDidUpdate(preProps: any, preState: any) {
        if (preProps.stamp !== this.props.stamp) {
            this.updateGroup();
        }

        if (preState.showItem.tid !== this.state.showItem.tid) {
            this.prepareGroupRechteLists();
            this.prepareGroupUsersLists();
        }
    }

    updateGroup() {
        const rechteBasis = this.props.rechteBasis;
        if (Array.isArray(rechteBasis.group_index) &&
            Array.isArray(rechteBasis.group_items) &&
            Array.isArray(rechteBasis.access_groups)) {

            const group: Array<any> = [];
            rechteBasis.group_index.map((ig: any) => {
                let cntUser = 0;
                rechteBasis.group_items.map((igi: any) => {
                    const group_id = igi.group_id_orig || igi.group_tid_orig;
                    if (group_id === ig.tid) {
                        cntUser++;
                    }
                });
                ig.cntUser = cntUser;

                let cntRecht = 0;
                rechteBasis.access_groups.map((iag: any) => {
                    const group_id = iag.group_id_orig || iag.group_tid_orig;
                    if (group_id === ig.tid) {
                        cntRecht++;
                    }
                });
                ig.cntRecht = cntRecht;

                group.push(ig);
            });

            // console.log(access);
            this.setState({ group });
        }
    }

    render() {
        const customActions = [
            {
                label: 'Rechte und Benutzer zuordnen',
                key: 'REFERENCE',
                func: ((row: any) => {
                    this.setState({ showZuordnenDialog: true, showItem: row });
                    return;
                }),
                info: 'Rechte und Benutzer zuordnen'
            }
        ];

        return (
            <div>
                <WFormsTableWrapper
                    module={this.props.modul}
                    entity={IDs.ENT_LEGACY_GROUPS}
                    data={this.state.group}
                    actions={['add', 'edit', 'delete']}
                    customActions={customActions}
                    customClass={this.props.costumClass ? this.props.costumClass : null}
                    formLayout={this.props.formLayout ? this.props.formLayout : null}
                    customColumns={[
                        { accessor: 'cntRecht', Header: 'Anzahl Rechte', id: 'cntRecht' },
                        { accessor: 'cntUser', Header: 'Anzahl Benutzer', id: 'cntUser' }
                    ]}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' && typeof this.props.onDataChange === 'function') {
                            this.props.onDataChange();
                        }
                    }}
                />
                {this.state.showZuordnenDialog && this.showZuordnenDialog()}
            </div>
        );
    }

    showZuordnenDialog() {
        return (
            <div>
                <DialogWrapper2
                    title='Rechte und Benutzer zuordnen'
                    onAfterClose={() => this.setState({ showZuordnenDialog: false, showItem: {} })}
                >
                    <div>
                        <div>
                            <div className={style.dnd_box}>
                                <div>Rechte dieser Gruppe</div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.groupRechteLists}
                                        onChange={(list: any) => this.setState({ groupRechteLists: list })}
                                    />
                                </div>
                            </div>
                            <div className={style.dnd_box}>
                                <div>Benutzer dieser Gruppe </div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.groupUsersLists}
                                        onChange={(list: any) => this.setState({ groupUsersLists: list })}
                                    />
                                </div>
                            </div>
                        </div>
                        <button
                            style={{ padding: '5px 10px', margin: 5, float: 'right' }}
                            onClick={() => {
                                this.setState({ showZuordnenDialog: false, showItem: {} });
                                // console.log(this.state);
                                // console.log(this.props.rechteBasis);
                                this.saveGroupRechteLists();
                                this.saveGroupUsersLists();
                            }}>Speichern</button>
                    </div>
                </DialogWrapper2>
            </div>
        );
    }

    prepareGroupRechteLists() {
        const groupRechteLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        if (Array.isArray(this.props.rechteBasis.access)) {
            this.props.rechteBasis.access.map((it: any) => {
                groupRechteLists.OPTIONS.push({
                    id: it.tid,
                    content: it.info
                });
            });
        }
        if (this.state.showItem.tid && Array.isArray(this.props.rechteBasis.access_groups)) {
            this.props.rechteBasis.access_groups.map((it: any) => {
                const group_id = it.group_id_orig || it.group_tid_orig;
                if (group_id === this.state.showItem.tid) {
                    const opIdx = groupRechteLists.OPTIONS.findIndex((it2: any) => { return it2.id === it.access_id_orig; });
                    if (opIdx >= 0) {
                        const opItemArray = groupRechteLists.OPTIONS.splice(opIdx, 1);
                        groupRechteLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        this.setState({ groupRechteLists });
    }

    prepareGroupUsersLists() {
        const groupUsersLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        console.log(this.props.rechteBasis);
        if (Array.isArray(this.props.rechteBasis.entity_user)) {
            this.props.rechteBasis.entity_user.map((it: any) => {
                const login = it.login ? it.login : it.Login ? it.Login : it.name;
                if (!login || login === null) {
                    return;
                }
                groupUsersLists.OPTIONS.push({
                    id: login,
                    content: login
                });
            });
        }
        if (this.state.showItem.tid && Array.isArray(this.props.rechteBasis.group_items)) {
            this.props.rechteBasis.group_items.map((it: any) => {
                const group_id = it.group_id_orig || it.group_tid_orig;
                if (!group_id) {
                    console.log('Invalid group item ', it);
                }
                if (group_id === this.state.showItem.tid) {
                    const opIdx = groupUsersLists.OPTIONS.findIndex((it2: any) => { return it2.id === it.name; });
                    if (opIdx >= 0) {
                        const opItemArray = groupUsersLists.OPTIONS.splice(opIdx, 1);
                        groupUsersLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        this.setState({ groupUsersLists });
    }

    saveGroupRechteLists() {
        const { groupRechteLists } = this.state;
        const { SELECTED, OPTIONS } = groupRechteLists;
        const access_groups = this.props.rechteBasis.access_groups;
        const groupTid = this.state.showItem.tid;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const accessId = parseInt(s.id, 10);
            const fnd = access_groups.find((ag: any) => ag.access_id_orig === accessId && ag.group_tid_orig === groupTid);
            if (!fnd) {
                console.log('addAccessGroups', groupTid, accessId);
                callCnt++;
                this.rechteService.addAccessGroups(groupTid, accessId, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const accessId = parseInt(o.id, 10);
            access_groups.filter((ag: any) => ag.access_id_orig === accessId && ag.group_tid_orig === groupTid)
                .forEach((ag: any) => {
                    console.log('delAccessGroups', ag.tid, ag.access_id);
                    callCnt++;
                    this.rechteService.delAccessGroups(ag.tid, groupTid, callback);
                });
        });
    }

    saveGroupUsersLists() {
        const { groupUsersLists } = this.state;
        const { SELECTED, OPTIONS } = groupUsersLists;
        const group_items = this.props.rechteBasis.group_items;
        const groupTid = this.state.showItem.tid;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const user = s.id;
            const fnd = group_items.find((gi: any) => gi.group_tid_orig === groupTid && gi.name === user);
            if (!fnd) {
                console.log('addGroupUser', groupTid, user);
                callCnt++;
                this.rechteService.addGroupUser(groupTid, user, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const user = o.id;
            group_items.filter((gi: any) => gi.group_tid_orig === groupTid && gi.name === user)
                .forEach((gi: any) => {
                    console.log('delGroupUser', gi.tid, user);
                    callCnt++;
                    this.rechteService.delGroupUser(gi.tid, groupTid, callback);
                });
        });
    }
}
